import { Music2 } from "lucide-react";
import { mediaUrl } from "../lib/api";

const hue = (id = "") => [...id].reduce((a, c) => a + c.charCodeAt(0), 0) % 360;

export const Cover = ({ song, className = "", testId }) => {
  if (song?.cover_path) {
    return (
      <img data-testid={testId} src={mediaUrl(song.cover_path)} alt={song.title}
        className={`object-cover bg-[var(--c-elev)] ${className}`} loading="lazy" />
    );
  }
  const h = hue(song?.id);
  return (
    <div data-testid={testId} className={`flex items-center justify-center ${className}`}
      style={{ background: `linear-gradient(135deg, hsl(${h} 70% 22%), hsl(${(h + 60) % 360} 70% 10%))` }}>
      <Music2 className="w-1/3 h-1/3 text-white/40" />
    </div>
  );
};

export const EqBars = ({ className = "" }) => (
  <span className={`inline-flex items-end gap-[2px] h-3 ${className}`}>
    {[0, 0.2, 0.4, 0.1].map((d) => (
      <span key={`eq-${d}`} className="eq-bar w-[3px] h-full bg-[var(--c-orange)] rounded-sm" style={{ animationDelay: `${d}s` }} />
    ))}
  </span>
);
